module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Chamados - Relatório'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Chamados")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Relatório',
        href: '#'
      }, {
        text: 'Chamados',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    attrs: {
      "id": "painel"
    }
  }, [_c('iframe', {
    staticStyle: {
      "height": "800px",
      "width": "9000px"
    },
    attrs: {
      "src": _vm.link,
      "frameborder": "0",
      "allowfullscreen": "true"
    }
  })])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4318ef5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/chamado/RelatorioChamado.vue
// module id = 1932
// module chunks = 1